import * as $ from 'jquery';
import { tracePayUrl } from "../../../constants/url.constant";
import { DefaultService } from '../../common/services/DefaultService';

export class BeesInvoiceService extends DefaultService {
    private static controller: string = "beesInvoice";

    public static RouteGetList = (token: string, year: number, month: number) =>
        `/${this.controller}/GetListForPrint/${token}?year=${year}&month=${month}`;

    public static getList(token: string, year: number, month: number): JQueryPromise<any> {
        return $.ajax(tracePayUrl + this.RouteGetList(token, year, month), {
            type: 'get',
            contentType: 'application/json'
        });
    }
}